import { render, staticRenderFns } from "./InstructorAboutYou.vue?vue&type=template&id=3b377c00&scoped=true"
import script from "./InstructorAboutYou.vue?vue&type=script&lang=js"
export * from "./InstructorAboutYou.vue?vue&type=script&lang=js"
import style0 from "./InstructorAboutYou.vue?vue&type=style&index=0&id=3b377c00&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b377c00",
  null
  
)

export default component.exports